import angular from 'angular';
import uiRouter from 'angular-ui-router';

let adpDataMappingToggleModule = angular.module('adpDataMappingToggle', [
  uiRouter
])

.directive('datamappingToggle', function() {
  function link(scope, element, attrs) {
    element.bind('click', e => {
      scope.datamappingToggle({
        $event: {el: element[0]},
        $id: scope.modelId
      });

      scope.$apply();
    });

    scope.$watch('isSelected', () => {
      if(scope.isSelected && !scope.clickEnabled) {
        scope.datamappingToggle({
          $event: {el: element[0]},
          $id: scope.modelId
        });
      }
    });
  }
  return {
    restrict: 'A',
    scope: {
      datamappingToggle: "&",
      modelId: "@",
      isSelected: "@",
      clickEnabled: "@"
    },
    link: link,
  };
})

.name;

export default adpDataMappingToggleModule;





// WEBPACK FOOTER //
// ./src/app/directives/dataMappingToggle.js